import { StationFrequency } from './StationFrequency';
import { StationGeneration } from './StationGeneration';
import { StationReceiverType } from './StationReceiverType';
import { StationLocation } from './StationLocation';
import { StationFlash } from './StationFlash';
import { StationStatusFlat } from 'models/base-station-status';

export enum StationType {
  station = 'station',
  flash = 'flash',
  location = 'location',
  lorawan = 'lorawan',
}

export interface Station<T = StationType.station> {
  id: number;
  owner_id: number;
  generation: StationGeneration;
  receiver_type: StationReceiverType;
  frequency?: StationFrequency;
  location?: StationLocation;
  status?: StationStatusFlat;
  type: T
};

export interface StationWithStatus extends Station {
  status?: StationStatusFlat;
}

export type BaseStation = Station & { status?: StationStatusFlat } // base station
export type FlashStation = Station<StationType.flash> & { flash: StationFlash } // station with "software update" status. can't attach / detach location
export type LocationStation = Partial<Station<StationType.location>> & { location: StationLocation } // location (without station)
export type LorawanStation = Pick<Station, 'id' | 'owner_id' | 'location' | 'status'> & { // lorawan-type stations
  type: StationType.lorawan,
  name: string;
  aws_id: string;
  eui: string;
  rf_region: string;
  lastMsg?: string;
}

export type StationEntity = BaseStation | FlashStation | LocationStation | LorawanStation;

export interface GetStationParams {
  stationIds?: number[],
  ownerId?: number,
  city?: string,
  country?: string,
  offset?: number,
  limit?: number,
}

// send null if you want remove field value
export interface StationUpdate {
  ownerId: number,
  generation: StationGeneration,
  receiverType: StationReceiverType,
  frequency?: StationFrequency | null,
  locationId?: number | null,
}

export interface LoRaWANStationUpdate {
  owner_id: number;
  locationId?: number | null;
  aws_id?: string;
  eui: string;
  rf_region: string;
  name: string;
}

export interface StationCreate {
  id: number,
  ownerId: number,
  generation: StationGeneration,
  receiverType: StationReceiverType,
  frequency?: StationFrequency,
}

export interface StationLoRaWANCreate {
  eui: string
  owner_id: number
}
